import React, { useEffect, useState } from "react";
import { Outlet, useSearchParams, useLocation } from "react-router-dom";

import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import "../../../admin.css";
import "./authentication.css";
import Footer from "./Footer";
import { useConfiguration } from "./Configuration";

const Authentication: React.FC = () => {
    const { state, dispatch, setActiveView, verifySetPasswordNonce, checkLogin } = useAuthenticationStore();
    const { activeView, signInId } = state;
    const { configuration } = useConfiguration();
    const { userType } = configuration;
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const [initialized, setInitialized] = useState(false);

    // Initial load effects
    useEffect(() => {
        const signInIdParam = searchParams.get("signInId");
        const emailParam = searchParams.get("email");
        const nonceParam = searchParams.get("nonce");

        if (emailParam) {
            dispatch({
                type: "SET_EMAIL",
                payload: emailParam,
            });
        }

        if (signInIdParam) {
            dispatch({ type: "SET_SIGN_IN_ID", payload: signInIdParam });
        }

        if (nonceParam) {
            dispatch({ type: "SET_VERIFICATION_CODE", payload: nonceParam });
        }

        if (emailParam && nonceParam) {
            verifySetPasswordNonce(emailParam, nonceParam, location.pathname === "/").then(() => {
                setInitialized(true);
                dispatch({ type: "SET_LOGIN_CHECK_TIMER", payload: window.setInterval(checkLogin, 1500) });
            });
        } else {
            if (location.pathname === "/" && state.totpKey) {
                setActiveView(AuthenticationViews.enableMfa);
            } else if (location.pathname === "/" && configuration.hasMfaConfig && signInId) {
                setActiveView(AuthenticationViews.verifyMfa);
            }
            setInitialized(true);
            dispatch({ type: "SET_LOGIN_CHECK_TIMER", payload: window.setInterval(checkLogin, 1500) });
        }
    }, []);

    // Update the active view when the URL changes
    useEffect(() => {

        if (!location.pathname) {
            dispatch({ type: "SET_ACTIVE_VIEW", payload: undefined });
            return;
        }
        const newLocation = location.pathname.substring(1) as AuthenticationViews;
        dispatch({ type: "SET_ACTIVE_VIEW", payload: newLocation });
    }, [location]);

    // Changes when the active view changes
    useEffect(() => {
        if (!activeView) return;

        dispatch({
            type: "SET_SERVER_ERROR",
            payload: "",
        });
    }, [activeView]);

    return (
        <div id="authentication" className={`rk-admin user-${userType.toLowerCase()}`}>
            {initialized && <Outlet />}
            {!initialized && <main />}
            <Footer />
        </div>
    );
};

export default Authentication;
